import { FormGroup, FormControl, ValidatorFn, ValidationErrors } from "@angular/forms";

export const PasswordMismatchValidator: ValidatorFn = (
  group: FormGroup<{
    newPassword: FormControl<string | null>,
    newPasswordRepeated: FormControl<string | null>
  }>
): ValidationErrors | null => {
  const newPassword = group.value.newPassword;
  const newPasswordRepeated = group.value.newPasswordRepeated;

  if (newPassword !== newPasswordRepeated) {
    return { passwordMismatch: true };
  }

  return null;
};
